import React from "react";
import { Box, Card, CardContent, Typography, Chip, Alert } from "@mui/material";
import RoomIcon from "@mui/icons-material/Room";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import GooglePlacesAutocomplete from "../../../../../components/GooglePlacesAutocomplete";

export default function DeliveryCard({
  config,
  setupSelected,
  addressText,
  locality,
  distanceKm,
  deliveryFee,
  addressConfirmed,
  onAddressTextChange,
  onPlaceSelect,
}) {
  const needsAddress = true; // delivery path always needs address
  const showInlineWarning =
    needsAddress && !addressConfirmed && addressText.length > 0;

  return (
    <Card variant="outlined" sx={{ borderRadius: 3, height: "100%" }}>
      <CardContent sx={{ p: 2.25 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
          Delivery details
        </Typography>

        <GooglePlacesAutocomplete
          label="Event address (select from suggestions)"
          value={addressText}
          onChange={onAddressTextChange}
          onSelect={onPlaceSelect}
          showWarningIfUnconfirmed={false}
          confirmed={addressConfirmed}
        />

        {needsAddress && !addressConfirmed && (
          <Typography
            variant="caption"
            sx={{ mt: 1, display: "block", color: "warning.main" }}>
            Please select an address from the suggestions to continue.
          </Typography>
        )}

        {showInlineWarning && (
          <Alert severity="warning" sx={{ mt: 1.25 }}>
            Please select a valid address from the suggestions to continue.
          </Alert>
        )}

        <Box
          sx={{
            mt: 1.5,
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            alignItems: "center",
          }}>
          <Chip
            icon={<LocalShippingIcon />}
            size="small"
            label={
              setupSelected
                ? `Delivery: included`
                : `Delivery fee: $${deliveryFee.toFixed(2)}`
            }
          />
          <Chip
            icon={<RoomIcon />}
            size="small"
            variant="outlined"
            label={
              addressConfirmed
                ? locality
                  ? `Locality: ${locality}`
                  : "Locality detected"
                : "Select a suggested address"
            }
            color={addressConfirmed ? "default" : "warning"}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`Distance: ${Number(distanceKm || 0).toFixed(1)} km`}
          />
        </Box>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1, display: "block" }}>
          Delivery is distance-based from our shop at {config.origin?.address}.
        </Typography>
      </CardContent>
    </Card>
  );
}
